import TodaySchedule from './TodaySchedule';
import CalendarMonth from './CalendarMonth';

/** ホーム画面: 今日の予定 → 月間カレンダー（この順番を維持）。選択した日の予定はボトムシートで表示。 */
export default function HomeScreen({ active }) {
  return (
    <section className={`screen${active ? ' active' : ''}`}>
      <TodaySchedule />
      <CalendarMonth />
    </section>
  );
}
